import {
  any, boolean, date, nullable,
  number, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PrivateActMask = {
  actStatus: string,
  comments: string,
  createdAt: any,
  defaultStripeAccountId: string | nullable,
  firstInteractionTimestamp: date | nullable,
  fullName: string,
  isLocalLegend: boolean,
  maxTravelDistance: number,
  pendingShowReviewId: string | nullable,
  phoneNumber: string,
  preferredSeating: any,
  preferredVenueSize: any,
  preferredVenueType: any,
  primaryEmail: string,
  requiresGuarantee: boolean,
  requiresOtherAct: boolean,
  requiresPiano: boolean,
  tourDays: any,
  tourMonths: any,
  tourRegions: any,
  tourTimes: any,
  updatedAt: any,
  lastOnlineAt: date,
  numShowsFinished: number,
  defaultHyperwalletAccountId: string | nullable,
  identities: any,
  sexualities: any,
  genders: any,
  disability: string,
};
